export default __webpack_public_path__ + "assets/models/47254d6cd671244dd60b7601302e4760.glb";